export class TenantDataFile {
  id: string;
  name: string;
  createdByUserId: string;
  createdByTenantId: string;
  fileType: string;
  downloadUrl: string;
  dateCreatedUtc: string;
  deviceSerialNumber: string;
  deviceModel: string;
  sizeInBytes: number;
  folderId: string;
  fileExtension: string;
  checksum: string;
  version: number;
  fileSyncStatus: string;
}

export class TenantDataFileFolderResponse {
  id: string;
  name: string;
  dateCreatedUtc: string;
  sizeInBytes: number;
  displayType: string;
  fileExtension: string;
  downloadUrl: string;
  parentId: string;
  fileSyncStatus: string;
}
